module.exports = __webpack_public_path__ + "static/img/advantage4.1c93a86e.png";